import { Dispatch } from 'redux';
import * as types from '../constants/actionTypes';
import { COUNTRIES_DATA } from '../constants/constants';
import { IAction } from '../interfaces/IAction';
import accountSettingService from '../services/accountSettingService';

interface UpdateUserPhoneSuccessPayload {
  dataKey: string[];
  dataValue: any;
}

interface UpdateUserPhoneSuccessAction {
  type: typeof types.UPDATE_USER_LOGIN_STATE;
  data: UpdateUserPhoneSuccessPayload;
}

interface UpdateUserNameSuccessAction {
  type: typeof types.UPDATE_USER_LOGIN_STATE;
  data: UpdateUserPhoneSuccessPayload;
}

interface UpdateUserEmailAddressAction {
  type: typeof types.UPDATE_USER_LOGIN_STATE;
  data: UpdateUserPhoneSuccessPayload;
}

interface SelectCountryPhoneCodeAction {
  type: typeof types.UPDATE_USER_LOGIN_STATE;
  data: UpdateUserPhoneSuccessPayload;
}

interface UnPauseAccountSuccessAction {
  type: typeof types.UNPAUSE_ACOUNT;
  data: {};
}

export function updateUserUserPhoneSuccess(data: any): UpdateUserPhoneSuccessAction {
  return {
    type: types.UPDATE_USER_LOGIN_STATE,
    data: { dataKey: ['userInfo', 'userPhone'], dataValue: data },
  };
}

export function updateUserNameSuccess(data: any): UpdateUserNameSuccessAction {
  return {
    type: types.UPDATE_USER_LOGIN_STATE,
    data: { dataKey: ['userInfo', 'displayName'], dataValue: data },
  };
}

export function updateUserEmailAddress(data: any): UpdateUserEmailAddressAction {
  return {
    type: types.UPDATE_USER_LOGIN_STATE,
    data: { dataKey: ['userInfo', 'emailAddress'], dataValue: data },
  };
}

export function selectCountryPhoneCode(data: any): SelectCountryPhoneCodeAction {
  return {
    type: types.UPDATE_USER_LOGIN_STATE,
    data: { dataKey: ['phoneNumberCountryCode'], dataValue: data },
  };
}

export function unPauseAccountSuccess(): UnPauseAccountSuccessAction {
  return { type: types.UNPAUSE_ACOUNT, data: {} };
}

export function getUserPhone() {
  return async (dispatch: Dispatch<IAction>) => {
    const res = await accountSettingService.getUserPhone();
    if (res && res.success) {
      if (res.data) {
        const phoneCode = res.data.phoneAlpha2Code && res.data.phoneAlpha2Code !== '' ? res.data.phoneAlpha2Code : res.data.userCountryCode;
        const country = COUNTRIES_DATA.filter(item => item.code === phoneCode);
        if (country.length > 0 && country[0]) {
          dispatch(selectCountryPhoneCode(country[0]));
        }
      }
      dispatch(updateUserUserPhoneSuccess(res.data));
    } else {
      console.log('ERROR: accountSetttingActions/getDataPageHome', res.message);
    }
  };
}

export function updateUserPhone(params: any) {
  return async (dispatch: Dispatch<IAction>) => {
    const res = await accountSettingService.postUpdateUserPhone(params);
    if (res && res.success) {
      if (res.data) {
        const country = COUNTRIES_DATA.filter(item => item.code === res?.data?.phoneAlpha2Code);
        if (country.length > 0 && country[0]) {
          dispatch(selectCountryPhoneCode(country[0]));
        }
      }
      dispatch(updateUserUserPhoneSuccess(res.data));
    } else {
      console.log('ERROR: accountSetttingActions/getDataPageHome', res.message);
    }
    return res;
  };
}

export function patchUpdateEmailAddress(params: any) {
  return async (dispatch: Dispatch<IAction>) => {
    const generateParam = {
      NewEmailAddress: params.email,
    };
    const res = await accountSettingService.patchEmailAddress(generateParam);
    if (res.success && res.data.Result) {
      dispatch(updateUserEmailAddress(params.email));
    } else {
      console.log('ERROR: accountSetttingActions/patchUpdateUserName', res.message);
    }
    return res
  };
}

export function patchUpdateUserName(params: any) {
  return async (dispatch: Dispatch<IAction>) => {
    const generateParam = {
      Username: params.name,
    };
    const res = await accountSettingService.patchUserName(generateParam);
    if (res.success && res.data.Result) {
      dispatch(updateUserNameSuccess(params.name));
    } else {
      console.log('ERROR: accountSetttingActions/patchUpdateUserName', res.message);
    }
    return res
  };
}

export function patchUpdatePassword(params: any) {
  return async () => {
    const generateParam = {
      OldPassword: params.oldPassword,
      NewPassword: params.newPassword,
    };
    const res = await accountSettingService.patchPassword(generateParam);
    if (!res.success || !res.data.Result) {
      console.log('ERROR: accountSetttingActions/patchPassword', res.message);
    }
    return res
  };
}

export function unPauseAccount() {
  return async (dispatch: Dispatch<IAction>) => {
    const res = await accountSettingService.postUnPauseAccount();
    if (res.success) {
      dispatch(unPauseAccountSuccess());
    } else {
      console.log('ERROR: accountSetttingActions/patchUnPauseAccount', res.message);
    }
  };
}

export function createUserPassword(params: any) {
  return async () => {
    const generateParam = {
      NewPassword: params.newPassword,
    };
    return accountSettingService.createPassword(generateParam);
  };
}
